import geopinTokens from "@amzn/meridian-tokens/base/icon/geopin";
import imageTokens from "@amzn/meridian-tokens/base/icon/image";
import Box from "@amzn/meridian/box";
import Button from "@amzn/meridian/button";
import Heading from "@amzn/meridian/heading";
import Icon from "@amzn/meridian/icon";
import Row from "@amzn/meridian/row";
import React, { useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import Page from "../../../components/page/Page";
import { Tabs } from "../../../components/tabs/Tabs";
import AttributesPanel from "./AttributesPanel";
import { IArtifactDetailsProps } from "./definitions";
import { ImageGalleryModal } from "../../../components/appeals/property-images/ImageGalleryModal";
import { FileUploadModal } from "../../../components/appeals/property-images/UploadImage";
import { TangoDataSheet } from "../../../components/tango-data/TangoDataSheet";
import {
    imageTypeMapping,
    updateArtifactDetails,
} from "../../../components/appeals/property-images/utils";
import { useUpdateArtifactDetailsByIdMutation } from "../../../endpoints/updateArtifactDetailsById";
import { useAppSelector } from "../../../app/store/hooks";

const ArtifactDetailsPageSkeleton: React.FC<IArtifactDetailsProps> = ({
    parcelId,
    data,
    detailsSectionHeight,
    artifactDetails,
    tabs,
    refetch,
}) => {
    const navigate = useNavigate();
    const [isGalleryOpen, setIsGalleryOpen] = useState(false);
    const [isFileUploadOpen, setFileUploadOpen] = useState(false);
    const { alias } = useAppSelector(state => state.auth.user);
    const { propertyId } = useParams();
    const [updateArtifact] = useUpdateArtifactDetailsByIdMutation();
    const handleGoogleMapPinClick = () => {
        // Handle Google Map pin click
    };

    const handleViewImageClick = () => {
        // Handle View Image click
        // open modal
        setIsGalleryOpen(true);
    };

    const handleUploadComplete = uploadedFiles => {
        console.log("Uploaded files:", uploadedFiles);
    };

    const handleNavigationTo = () => {
        navigate(`edit-${parcelId ? "parcel" : "property"}`, {
            state: {
                propertyNumber: data?.propertyDetails?.propertyNumber,
                parcelNumber: data?.artifactDetails?.parcelNumber,
                data: data,
            },
        });
    };

    const fileTypes = Object.entries(imageTypeMapping).map(([value, label]) => ({
        value,
        label,
    }));

    const [open, setOpen] = useState(false);

    const getTitle = () =>
        parcelId ? data["artifactDetails"]?.parcelNumber : data["propertyDetails"]?.propertyNumber;

    return (
        <Page
            type="form"
            title={getTitle()}
            description="testDescription"
            hasBreadcrumbs
            actions={null}
        >
            <Row
                wrap="down"
                width="auto"
                minWidth={"950px"}
                alignmentHorizontal={"justify"}
                widths={["fill", "fit", "fit"]}
                spacing="350"
            >
                <Box>
                    <Box height="6px" />
                    <Heading level={1} type="d50">
                        {getTitle()}
                    </Heading>
                </Box>
                <Box>
                    <Button onClick={handleGoogleMapPinClick} type="secondary" size="medium">
                        <Icon tokens={geopinTokens} color="primary" />
                    </Button>
                </Box>
                <Box>
                    <Button onClick={handleViewImageClick} type="secondary" size="medium">
                        <Icon tokens={imageTokens} color="primary" />
                    </Button>
                </Box>
                <Box>
                    <Button onClick={handleNavigationTo} type="secondary" size="medium">
                        {parcelId ? "Edit Parcel" : "Edit Property"}
                    </Button>
                </Box>
            </Row>
            <Row width="40%">
                <Box spacingInset="100">
                    <Heading color="secondary" type="b300" level={1}>
                        {parcelId
                            ? data["artifactDetails"]?.address.streetAddress
                            : data["propertyDetails"]?.address.streetAddress}
                    </Heading>
                </Box>
            </Row>
            <Box height="10px" />

            <AttributesPanel height={detailsSectionHeight} rows={artifactDetails} />
            {!parcelId ? (
                <>
                    <ImageGalleryModal
                        data={data}
                        isOpen={isGalleryOpen}
                        onClose={() => {
                            setIsGalleryOpen(false);
                            refetch();
                        }}
                        setFileUploadModal={setFileUploadOpen}
                        imageTypes={fileTypes}
                    />
                    <FileUploadModal
                        isOpen={isFileUploadOpen}
                        onClose={() => setFileUploadOpen(false)}
                        onUploadComplete={handleUploadComplete}
                        title="Upload Property Images"
                        updateFunction={newFiles =>
                            updateArtifactDetails(updateArtifact, data, propertyId, alias, [
                                ...(data.propertyDetails["propertyImages"] || []),
                                ...newFiles,
                            ])
                        }
                        fileTypes={fileTypes}
                        maxFiles={5}
                        acceptedFileTypes={["image/jpeg", "image/png"]}
                        propertyId={propertyId}
                        refetch={refetch}
                    />
                </>
            ) : (
                <></>
            )}
            {parcelId ? (
                <></>
            ) : (
                <>
                    <Button onClick={() => setOpen(true)} type="tertiary">
                        Show Tango Data
                    </Button>
                    <TangoDataSheet data={data} open={open} setOpen={setOpen} />
                    <Box height={"20px"} />
                </>
            )}
            <Tabs tabs={tabs} />
        </Page>
    );
};

export default ArtifactDetailsPageSkeleton;
